import { Box, Button, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import React from 'react';

import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';

interface SettingItemProps {
	title: string;
	children: React.ReactNode;
	isEditMode?: boolean;
	button?: {
		label: string;
		onClick: () => void;
		disabled?: boolean;
	};
	sx?: React.CSSProperties;
}

const SettingItem: React.FC<SettingItemProps> = ({
	title,
	button,
	isEditMode = false,
	children,
	sx,
}) => {
	return (
		<Grid
			container
			direction="column"
			sx={{
				borderRadius: borderRadius.lg,
				border: `1px solid ${palette.elevation.outlined}`,
				padding: spaces.md,
				backgroundColor: palette.background.paperElevation2,
				gap: spaces.xs,
				...sx,
			}}
		>
			<Grid item>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						width: '100%',
					}}
				>
					<Typography
						color="text.primary"
						sx={{
							fontFamily: 'Borna',
							fontSize: '18px',
							fontStyle: 'normal',
							fontWeight: 500,
							lineHeight: '28px',
							letterSpacing: '0.15px',
						}}
					>
						{title}
					</Typography>
					{button && isEditMode && (
						<Button
							data-testid="setting-item-button"
							onClick={button.onClick}
							disabled={button?.disabled}
							variant="text"
							color="primary"
							size="small"
						>
							{button.label}
						</Button>
					)}
				</Box>
			</Grid>
			<Grid item>
				<Box>{children}</Box>
			</Grid>
		</Grid>
	);
};

export default SettingItem;
